<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M18 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2zm-1 13H7V7h10zM27.5 9h15a1.5 1.5 0 000-3h-15a1.5 1.5 0 000 3zM42.5 15h-15a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3zM18 28H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V30a2 2 0 00-2-2zm-1 13H7V31h10zM42.5 30h-15a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3zM42.5 39h-15a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3z"/></svg>